import { BaseService, Service } from "/@/cool";
@Service("allRepairOrder")
class AllRepairOrder extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["add"] = prefix + "add";
		this.permission["page"] = prefix + "page";
		this.permission["allRepairOrderPage"] = prefix + "allRepairOrderPage";
		this.permission["priorityOrderList"] = prefix + "priorityOrderList";
		this.permission["assignMember"] = prefix + "assignMember";
		this.permission["pageForPreCheck"] = prefix + "pageForPreCheck";
		this.permission["preCheckPass"] = prefix + "preCheckPass";
		this.permission["getPreCheckRecord"] = prefix + "getPreCheckRecord";
		this.permission["preCheckRecordList"] = prefix + "preCheckRecordList";
		this.permission["pageForRepairDemand"] = prefix + "pageForRepairDemand";
		this.permission["addRepairDemand"] = prefix + "addRepairDemand";
		this.permission["startPreCheck"] = prefix + "startPreCheck";
		this.permission["startOnlineRepair"] = prefix + "startOnlineRepair";
		this.permission["getPreCheckWorkInfo"] = prefix + "getPreCheckWorkInfo";
		this.permission["claimPreCheckOrder"] = prefix + "claimPreCheckOrder";
		this.permission["claimOnlineRepairOrder"] = prefix + "claimOnlineRepairOrder";
	}

	// add(params: any) {
	//     return this.request({
	//         url: "/add",
	//         method: "POST",
	//         data: { ...params }
	//     });
	// }

	preCheckRecordList(data: any) {
		return this.request({
			url: "/preCheckRecordList",
			method: "POST",
			data
		});
	}

	getPreCheckRecord(params: any) {
		return this.request({
			url: "/getPreCheckRecord",
			method: "POST",
			params: { ...params }
		});
	}

	preCheckPass(data: any) {
		return this.request({
			url: "/preCheckPass",
			method: "POST",
			data
		});
	}

	pageForPreCheck(data: any) {
		return this.request({
			url: "/pageForPreCheck",
			method: "POST",
			data
		});
	}

	allRepairOrderPage(params: any) {
		return this.request({
			url: "/allRepairOrderPage",
			method: "GET",
			params: { ...params }
		});
	}

	priorityOrderList(params: any) {
		return this.request({
			url: "/priorityOrderList",
			method: "POST",
			params: { ...params }
		});
	}

	assignMember(params: any) {
		return this.request({
			url: "/assignMember",
			method: "POST",
			params: { ...params }
		});
	}

	pageForRepairDemand(params: any) {
		return this.request({
			url: "/pageForRepairDemand",
			method: "POST",
			params: { ...params }
		});
	}

	addRepairDemand(data: any) {
		return this.request({
			url: "/addRepairDemand",
			method: "POST",
			data
		});
	}

	startPreCheck(data: { repair_id: number }) {
		return this.request({
			url: "/startPreCheck",
			method: "POST",
			data
		});
	}

	startOnlineRepair(data: { repair_id: number }) {
		return this.request({
			url: "/startOnlineRepair",
			method: "POST",
			data
		});
	}

	getPreCheckWorkInfo(data: { repair_id: number }) {
		return this.request({
			url: "/getPreCheckWorkInfo",
			method: "POST",
			data
		});
	}

	claimPreCheckOrder() {
		return this.request({
			url: "/claimPreCheckOrder",
			method: "POST",
			data: {}
		});
	}

	claimOnlineRepairOrder() {
		return this.request({
			url: "/claimOnlineRepairOrder",
			method: "POST",
			data: {}
		});
	}
}
export default AllRepairOrder;
